const twitter_widget_js = 'https://platform.twitter.com/widgets.js'
export default twitter_widget_js
